import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '48',
  height: '41',
  viewBox: '0 0 48 41'
}, [
  h('ellipse', {
    cx: '24',
    cy: '15',
    rx: '6',
    ry: '3',
    fill: '#c0f2d6'
  }),
  h('ellipse', {
    cx: '24',
    cy: '4',
    rx: '6',
    ry: '3',
    fill: '#c0f2d6'
  }),
  h('ellipse', {
    cx: '38',
    cy: '10',
    rx: '6',
    ry: '3',
    fill: '#c0f2d6'
  }),
  h('ellipse', {
    cx: '11',
    cy: '10',
    rx: '6',
    ry: '3',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M17 15c0 2.3 3 4 7 4s7-1.7 7-4-3-4-7-4-7 1.7-7 4zm7-2c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2z',
    fill: '#0eb87f'
  }),
  h('path', {
    d: 'M48 14c0-.1 0-.2-.1-.3v-.1c0-.1-.1-.2-.2-.3l-.1-.1s-.1 0-.1-.1l-3.1-1.3c.4-.5.7-1.1.7-1.8 0-2.3-3-4-7-4-1.8 0-3.4.4-4.7 1l-3-1.3c.4-.5.6-1.1.6-1.7 0-2.3-3-4-7-4s-7 1.7-7 4c0 .6.2 1.2.6 1.7l-2.4 1.1C14 6.3 12.6 6 11 6c-4 0-7 1.7-7 4 0 .5.2 1 .4 1.4L.6 13.1s-.1 0-.1.1c-.1 0-.1.1-.2.1-.1.1-.1.2-.2.3v.1c-.1.1-.1.2-.1.3v16c0 .4.2.7.6.9l22 10c.1 0 .2.1.4.1.1 0 .2 0 .3-.1l24-10c.4-.2.6-.5.6-.9V14h.1zm-5-4c0 .3-.3.7-.9 1.1-.1 0-.2.1-.3.2-.9.4-2.2.7-3.8.7-3.1 0-5-1.2-5-2s1.9-2 5-2 5 1.2 5 2zM24 2c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2zm-4.6 5.1c1.2.6 2.8.9 4.6.9 1.8 0 3.4-.3 4.6-.9l3 1.3c-.4.5-.6 1-.6 1.6 0 2.3 3 4 7 4 1.7 0 3.3-.3 4.5-.9l2 .9L23 22.9 3.5 14l2.6-1.1C7.3 13.6 9 14 11 14c4 0 7-1.7 7-4 0-.7-.3-1.4-.8-1.9l2.2-1zM11 8c3.1 0 5 1.2 5 2s-1.9 2-5 2-5-1.2-5-2 1.9-2 5-2zm-9 7.6l20 9.1v13.8L2 29.4V15.6zm44 13.7l-22 9.2V24.7l22-9.2v13.8z',
    fill: '#0eb87f'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/page-ct.es6.js